export const ALL_PRODUCTS_GRAPHQL_QUERY = `
query {
  products(first: 40) {
    edges {
      node {
        id
        title
        productType: metafield(namespace: "custom", key: "product_type") {
          value
        }
        variants(first: 15) {
          edges {
            node {
              id
              sku: metafield(namespace: "custom", key: "product_id") {
                value
              }
              image {
                url
              }
            }
          }
        }
      }
    }
  }
}
`;
